import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { DesignA } from './designA/DesignA';
import { DesignB } from './designB/DesignB';
import { VariantDevControl } from './VariantDevControl';
import { useDiscover } from '../../contexts/DiscoverContext';

/**
 * Presents whichever Discover composition is currently scheduled.
 *
 * The switch happens here and only here. The provider above stays mounted, so a
 * search, a filter, a saved institution or a comparison in progress is carried
 * straight through the change — nothing is refetched, nothing navigates, and the
 * browser never reloads.
 *
 * The transition is a quiet crossfade. Nothing on screen announces that the
 * composition changed, because to the student it is one product, not two.
 */
const REGISTRY = {
  A: DesignA,
  B: DesignB
} as const;
export function DiscoverExperience() {
  const {
    variant
  } = useDiscover();
  const reduceMotion = useReducedMotion();
  const frame = useRef<HTMLDivElement>(null);
  const [lockedHeight, setLockedHeight] = useState<number | null>(null);
  const previous = useRef(variant);

  // Holding the frame at its current height while the outgoing composition
  // leaves stops the page collapsing under the scroll position — the student
  // stays where they were rather than being thrown to the top.
  useLayoutEffect(() => {
    if (previous.current !== variant && frame.current) {
      setLockedHeight(frame.current.offsetHeight);
      previous.current = variant;
    }
  }, [variant]);
  useEffect(() => {
    if (lockedHeight === null) return undefined;
    const timeout = window.setTimeout(() => setLockedHeight(null), 700);
    return () => window.clearTimeout(timeout);
  }, [lockedHeight]);
  const Composition = REGISTRY[variant];
  return <div ref={frame} style={lockedHeight ? {
    minHeight: lockedHeight
  } : undefined} data-id="element-1490" data-mp="3z8d219jjbpa">
      <AnimatePresence mode="wait" initial={false} data-id="element-1491" data-mp="3w3at5b7qvvfv">
        <motion.div key={variant} initial={reduceMotion ? false : {
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={reduceMotion ? {
        opacity: 1
      } : {
        opacity: 0
      }} transition={{
        duration: reduceMotion ? 0 : 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1492" data-mp="3w4lu739t2p3a">
          <Composition data-id="element-1493" data-mp="2dz5r55fz1y32" />
        </motion.div>
      </AnimatePresence>

      <VariantDevControl data-id="element-1494" data-mp="2i0h7slgvb8z4" />
    </div>;
}